export default __webpack_public_path__ + "static/media/plansSelect.023050a9.png";